{
  "version": 1,
  "asset_id": "c5f0027e-0a8a-4f1e-bd27-3f801d585c8d",
  "project_id": "ca7587fa-3476-4974-b258-69992cc9166e",
  "url": "/__l5e/assets-v1/c5f0027e-0a8a-4f1e-bd27-3f801d585c8d/werk-3.jpg",
  "r2_key": "a/v1/ca7587fa-3476-4974-b258-69992cc9166e/c5f0027e-0a8a-4f1e-bd27-3f801d585c8d/werk-3.jpg",
  "original_filename": "werk-3.jpg",
  "size": 91599,
  "content_type": "image/jpeg",
  "created_at": "2026-09-22T13:30:01Z"
}
